module.exports = __webpack_public_path__ + "img/HTI.63278320.svg";